var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"small":"","caption-top":"","fields":['label', 'parameter_value'],"items":_vm.parameters}})
}
var staticRenderFns = []

export { render, staticRenderFns }